import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import { RequireAuth } from 'routes/utils';
import { CalendarProvider } from 'hooks/calendar';

const ContactsList =     lazy(() => import(/* webpackChunkName: "contacts-list" */ 'pages/contacts-list'));
const HolidayAdd =       lazy(() => import(/* webpackChunkName: "holiday-add" */ 'pages/my-reminders/holiday-add'));
const HolidayView =      lazy(() => import(/* webpackChunkName: "holiday-view" */ 'pages/my-reminders/holiday-view'));
const MyReminders =      lazy(() => import(/* webpackChunkName: "my-reminders" */ 'pages/my-reminders'));
const Calendar =         lazy(() => import(/* webpackChunkName: "calendar" */ 'pages/calendar'));
const BirthdayAdd =      lazy(() => import(/* webpackChunkName: "birthday-add" */ 'pages/my-reminders/birthday-add'));
const BirthdayMore =     lazy(() => import(/* webpackChunkName: "birthday-more" */ 'pages/my-reminders/birthday-more'));
const ReminderManual =   lazy(() => import(/* webpackChunkName: "reminder-manual" */ 'pages/my-reminders/manual'));
const Browse =           lazy(() => import(/* webpackChunkName: "browse" */ 'pages/card/browse'));
const RemindersLanding = lazy(() => import(/* webpackChunkName: "reminders-landing" */ 'pages/reminders-landing'));


const renderReminderRoutes = () => [
  <Route
    key="my-contacts"
    name="my-contacts"
    path="/address_book"
    element={
      <RequireAuth redirectTo="/login?next=/address_book" strict>
        <ContactsList/>
      </RequireAuth>
    }
  />,
  <Route
    key="my-reminders"
    name="my-reminders"
    path="/reminders"
    element={
      <RequireAuth redirectTo="/login?next=/reminders" strict>
        <MyReminders/>
      </RequireAuth>
    }
  />,
  <Route
    key="calendar"
    name="calendar"
    path="/calendar"
    element={
      <RequireAuth redirectTo="/login?next=/calendar" strict>
        <Calendar/>
      </RequireAuth>
    }
  />,
  <Route
    key="reminders-landing"
    name="reminders-landing"
    path="/reminders/add"
    element={<RemindersLanding/>}
  />,
  <Route
    key="holiday-add"
    name="holiday-add"
    path="/reminders/holiday/add"
    element={
      <RequireAuth redirectTo="/login?next=/reminders/holiday/add" strict>
        <HolidayAdd/>
      </RequireAuth>
    }
  />,
  <Route
    key="holiday-view"
    name="holiday-view"
    path="/reminders/holiday"
    element={
      <RequireAuth redirectTo="/login?next=/reminders/holiday" strict>
        <HolidayView/>
      </RequireAuth>
    }
  />,
  <Route
    key="reminder-birthday-manual"
    name="reminder-birthday-manual"
    path="/reminders/birthday/add/manual"
    element={
      <RequireAuth redirectTo="/login?next=/reminders/birthday/add/manual" strict>
        <ReminderManual reminderType="birthday"/>
      </RequireAuth>
    }
  />,
  <Route
    key="reminder-anniversary-manual"
    name="reminder-anniversary-manual"
    path="/reminders/anniversary/add/manual"
    element={
      <RequireAuth redirectTo="/login?next=/reminders/anniversary/add/manual" strict>
        <ReminderManual reminderType="anniversary"/>
      </RequireAuth>
    }
  />,
  <Route
    key="reminder-landing"
    name="reminder-landing"
    path="/reminders/birthday/add"
    element={
      <RequireAuth redirectTo="/login?next=/reminders/birthday/add" strict>
        <BirthdayAdd/>
      </RequireAuth>
    }
  />,
  <Route
    key="reminder-more"
    name="reminder-more"
    path="/reminders/birthday/more"
    element={
      <RequireAuth redirectTo="/login?next=/reminders/birthday/more" strict>
        <BirthdayMore/>
      </RequireAuth>
    }
  />,
  <Route
    key="reminder-browse"
    name="reminder-browse"
    path="/:reminderType/browse"
    element={<CalendarProvider><Browse/></CalendarProvider>}
  />
];


export default renderReminderRoutes;
